export const kErrorTesterTileType = "ErrorTester"
export const kErrorTesterTileClass = "error-tester"
